class Report {
  addMetric () {}
  summary () {}
}

export default {
  Report: Report
}
